// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yvn {
  position: absolute;
  top: 40%;
  left: 58%;
  cursor: pointer;
  width: 25px;
  height: 25px;
}

.contact-item {
  position: absolute;
  top: 32%;
  left: 52%;
}

.content {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.item {
  width: 166px;
  padding: 10px;
  border-radius: 8px;
  background-color: #ffffff;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.item p {
  font-size: 12px;
  line-height: 20px;
  padding: 0;
  margin: 0;
  color: #667085;
}
.item p:first-child {
  color: #344054;
}
.item a {
  display: block;
  color: #0073b9;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
}

.arrow-down {
  width: 12px !important;
  height: 12px;
  position: absolute;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -50%);
  bottom: -15px;
} `, "",{"version":3,"sources":["webpack://./src/components/Location/Yerevan/yerevan.scss","webpack://./src/components/Location/Yerevan/yerevan.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;ACCF;;ADEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;ACCF;;ADEA;EACE,kBAAA;EACA,uBAAA;EAAA,kBAAA;ACCF;;ADEA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;ACCF;ADCE;EACE,eAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;ACCJ;ADCI;EACE,cAAA;ACCN;ADGE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;ACDJ;;ADKA;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,aAAA;ACFF","sourcesContent":[".yvn {\n  position: absolute;\n  top: 40%;\n  left: 58%;\n  cursor: pointer;\n  width: 25px;\n  height: 25px;\n}\n\n.contact-item {\n  position: absolute;\n  top: 32%;\n  left: 52%;\n}\n\n.content {\n  position: relative;\n  width: fit-content;\n}\n\n.item {\n  width: 166px;\n  padding: 10px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  color: black;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n\n  p {\n    font-size: 12px;\n    line-height: 20px;\n    padding: 0;\n    margin: 0;\n    color: #667085;\n\n    &:first-child {\n      color: #344054;\n    }\n  }\n\n  a {\n    display: block;\n    color: #0073b9;\n    font-size: 12px;\n    line-height: 14px;\n    font-weight: 400;\n  }\n}\n\n.arrow-down {\n  width: 12px !important;\n  height: 12px;\n  position: absolute;\n  left: 50%;\n  right: 50%;\n  transform: translate(-50%, -50%);\n  bottom: -15px;\n}\n",".yvn {\n  position: absolute;\n  top: 40%;\n  left: 58%;\n  cursor: pointer;\n  width: 25px;\n  height: 25px;\n}\n\n.contact-item {\n  position: absolute;\n  top: 32%;\n  left: 52%;\n}\n\n.content {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.item {\n  width: 166px;\n  padding: 10px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  color: black;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n}\n.item p {\n  font-size: 12px;\n  line-height: 20px;\n  padding: 0;\n  margin: 0;\n  color: #667085;\n}\n.item p:first-child {\n  color: #344054;\n}\n.item a {\n  display: block;\n  color: #0073b9;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: 400;\n}\n\n.arrow-down {\n  width: 12px !important;\n  height: 12px;\n  position: absolute;\n  left: 50%;\n  right: 50%;\n  transform: translate(-50%, -50%);\n  bottom: -15px;\n} /*# sourceMappingURL=yerevan.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
